import React, { FC, Fragment } from 'react';
import { Redirect, Switch } from 'react-router';
import { Route } from 'react-router';

import { ErrorPage, LocationBlock } from 'components';
import { useCurrentUser } from 'hooks';
import { NavBar } from 'features/header';
import * as paths from 'paths';
import ClientSuccess from 'clientSuccess';

import Logout from './Logout';
import { OnboardingWrapper, onboardingRoutes } from './Onboarding';
import { MainWrapper, mainRoutes } from './Main';

const Routes: FC = () => {
  const currentUser = useCurrentUser();

  const onboardingSteps = {
    null: paths.onboardingProfile, // server default - no steps completed
    0: paths.onboardingProfile, // server default - no steps completed
    1: paths.onboardingFollows,
  };

  const { last_onboarding_step, onboarding_completed, location } = currentUser;
  const nextStep = onboardingSteps[last_onboarding_step];

  return (
    <Fragment>
      <Switch>
        <Route exact path={paths.login} render={() => <Redirect to={paths.index} />} />
        <Route exact path={paths.invitation} render={() => <Redirect to={paths.index} />} />
        <Route exact path={paths.signUp} render={() => <Redirect to={paths.index} />} />
        <Route exact path={paths.confirmSignup} render={() => <Redirect to={paths.index} />} />
        <Route exact path={paths.logout} component={Logout} />
        {!onboarding_completed && (
          <Route exact path={paths.index} render={() => <Redirect to={nextStep} />} />
        )}
        {location && location.block_message && <Route component={LocationBlock} />}
        <Route
          path={paths.onboarding}
          render={() => (
            <OnboardingWrapper>
              <Switch>
                {onboardingRoutes.map(({ path, component }) => (
                  <Route key={path} exact path={path} component={component} />
                ))}
              </Switch>
            </OnboardingWrapper>
          )}
        />
        <Route path={paths.clientSuccess} render={() => <ClientSuccess />} />
        <Route
          path={paths.index}
          render={() => (
            <MainWrapper>
              <NavBar />
              <Switch>
                {mainRoutes.map(({ layoutPaths, component }) =>
                  layoutPaths.map(path => (
                    <Route key={path} exact path={path} component={component} />
                  ))
                )}
                <Route component={ErrorPage} />
              </Switch>
            </MainWrapper>
          )}
        />
      </Switch>
    </Fragment>
  );
};

export default Routes;
